import React from 'react';
import { useTranslation } from 'react-i18next';
import { TFormActions, TFormField } from '../../../reducers/formStateReducer';
import { FormInput } from '../../FormInput/FormInput';
import {
  getOnlyIntgerValue,
  isFieldEmpty,
  validateFieldLength,
} from '../validators';

export const LastFourDigitsField: React.FC<{
  setState: React.Dispatch<TFormActions>;
  value: TFormField;
}> = ({ setState, value: lastFourDigits }) => {
  const { t } = useTranslation();

  const validateField = () =>
    !isFieldEmpty('lastFourDigits', lastFourDigits) &&
    !validateFieldLength('lastFourDigits', lastFourDigits)
      ? setState({
          type: 'fieldError',
          value: { fieldName: 'lastFourDigits', hasError: true },
        })
      : setState({
          type: 'fieldError',
          value: { fieldName: 'lastFourDigits', hasError: false },
        });

  return (
    <FormInput
      dataHook="last-four-digits"
      maxLength={999}
      statusMessage={t(
        'charge-locator.charge_locator_form.field_error.invalid_last_4_digits',
      )}
      value={lastFourDigits.value}
      status={lastFourDigits.hasError ? 'error' : undefined}
      onBlur={validateField}
      type="number"
      onChange={(e) =>
        setState({
          type: 'lastFourDigits',
          value: getOnlyIntgerValue({ value: e?.target?.value, maxLength: 4 }),
        })
      }
      label={t('charge-locator.charge-locator-form.card-number')}
    />
  );
};
